import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetModelsList({ enabled = true } = {}) {
  const fetchData = async () => {
    const response = await httpClient.get('team/models')
    const result = response.data.data?.map((i) => {
      return { ...i, is_enabled: !!i.is_enabled }
    })

    return result
  }

  return useQuery({
    queryKey: ['models'],
    queryFn: fetchData,
    placeholderData: [],
    enabled,
  })
}
